const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

// Reorder images
export const reorderPropertyMedia = async (
  propertyId: number,
  urls: string[],
  token: string,
): Promise<Response> => {
  const response = await fetch(`${apiBaseUrl}/properties/${propertyId}/media`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
    method: 'PUT',
    body: JSON.stringify({
      order: urls.map((url) => url.split('/').slice(-1)[0]),
    }),
  });

  if (!response.ok) {
    throw new Error(`Failed to reorder property media: ${response.statusText}`);
  }

  return response;
};
